/* =============================================================
   Sound Brothers — Slider-Fortschrittsbalken
   Ersetzt Dawns Zahlen-Zähler ("3 / 11") in allen Produkt-Slidern
   durch einen schlanken Balken, analog zur Scrollbar im
   Referenzen-Slider auf der Startseite.
   ============================================================= */
(function () {
  var CLASS = 'sb-slider-progress';

  function setup(counter) {
    if (counter.dataset.sbProgress) return;

    var host = counter.closest('slider-component');
    var slider = host && host.querySelector('.slider');
    if (!slider) return;

    counter.dataset.sbProgress = '1';
    counter.classList.add(CLASS);
    counter.setAttribute('aria-hidden', 'true');
    counter.innerHTML = '<span class="' + CLASS + '__thumb"></span>';

    var thumb = counter.firstElementChild;

    function update() {
      var max = slider.scrollWidth - slider.clientWidth;
      if (max <= 1) {
        counter.classList.add(CLASS + '--idle');
        return;
      }
      counter.classList.remove(CLASS + '--idle');

      // Breite des Reiters = sichtbarer Anteil, mind. 18 % damit er greifbar bleibt
      var anteil = Math.max(slider.clientWidth / slider.scrollWidth, 0.18);
      var fortschritt = slider.scrollLeft / max;

      thumb.style.width = anteil * 100 + '%';
      thumb.style.left = fortschritt * (100 - anteil * 100) + '%';
    }

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(slider);
    update();
  }

  function scan(root) {
    (root || document).querySelectorAll('.slider-counter').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // Theme-Editor rendert Sektionen neu
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
